import { apiMethods } from './api_methods';

// Here is the format of the request object im expecting
// {
//      method : "foo",
//      args : {
//          bar : "baz"
//      }
// }

class ApiClientRequests {
    constructor(promotion_config = {}) {
        this.auth_token = '';
        this.methods = apiMethods(promotion_config);
    }

    async apiMethod(requestData) {
        var retVal = null;

        const method = this.getMethod(requestData);

        if (method.action == 'get') {
            var getRoute = '/api/' + method.method;

            let getRequestData = this.urlEncode(requestData);

            if (getRequestData) {
                getRoute += getRequestData;
            }

            retVal = await this.getData(getRoute);
        } else if (method.action == 'post') {
            retVal = await this.postData('/api/' + method.method, this.buildObject(requestData));
        }

        return retVal;
    }

    getMethod(postingData) {
        return this.methods.filter((val) => {
            return postingData.method == val.name;
        })[0];
    }

    async getData(url = '') {
        if (typeof window !== 'undefined') {
            // Create the XHR request
            var request = new XMLHttpRequest();

            // Return it as a Promise
            return await new Promise(function (resolve, reject) {
                // Setup our listener to process compeleted requests
                request.onreadystatechange = function () {
                    // Only run if the request is complete
                    if (request.readyState !== 4) return;

                    // Process the response
                    resolve(JSON.parse(request.response));
                };

                // Setup our HTTP request
                request.open('GET', url, true);
                request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                request.setRequestHeader('Content-Type', 'application/json;charset=utf-8');
                request.withCredentials = true;

                request.send();
            });
        }
    }

    async postData(url = '', data = {}) {
        if (typeof window !== 'undefined') {
            // Create the XHR request
            var request = new XMLHttpRequest();

            // Return it as a Promise
            return await new Promise(function (resolve, reject) {
                // Setup our listener to process compeleted requests
                request.onreadystatechange = function () {
                    // Only run if the request is complete
                    if (request.readyState !== 4) return;

                    // Process the response
                    resolve(request.response ? JSON.parse(request.response) : {});
                };

                // Setup our HTTP request
                request.open('POST', url, true);
                // request.setRequestHeader('Accept', 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8')
                request.setRequestHeader('Content-Type', 'application/json;charset=utf-8');
                request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                request.withCredentials = true;
                // Send the request
                request.send(JSON.stringify(data));
            });
        }
    }

    buildObject(postingData) {
        const method = this.getMethod(postingData);

        var requestObj = {
            args: {},
        };

        method.args.forEach((arg) => {
            requestObj.args[arg.name] = arg.processArgs(postingData.args[arg.name]);
        });

        method.postBuild(postingData, requestObj);

        return requestObj;
    }

    urlEncode(postingData) {
        const method = this.getMethod(postingData);
        var requestObj = {};

        method.args.forEach((arg) => {
            let processedArg = arg.processArgs(postingData.args[arg.name]);

            if (processedArg) {
                requestObj[arg.name] = processedArg;
            }
        });

        var str = [];
        for (var p in requestObj) {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(requestObj[p]));
        }
        return '?' + str.join('&');
    }
}

const apiClient = (config) => {
    return new ApiClientRequests(config);
};
export default apiClient;
